import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

function pascalToCamel(str) {
  return str.charAt(0).toLowerCase() + str.slice(1);
}

export function mapApiErrorsToFormik(error, setErrors) {
  if (error?.response) {
    const { status, data } = error.response;
    if (status === 400 && data?.errors) {
      const fieldErrors = {};
      for (const field in data.errors) {
        const messages = data.errors[field];
        if (Array.isArray(messages) && messages.length > 0) {
          const firstMessage = messages[0];
          const normalizedKey = pascalToCamel(field);

          fieldErrors[normalizedKey] = firstMessage;
        }
      }
      setErrors(fieldErrors);
      return true;
    }
  }
  return false;
}
